<template>
  <div class="container">
    <div class="row faqs mx-auto mb-5">
      <div class="col-md-12">
        <h1 class="text-uppercase text-center mt-5 mb-5">
          Frequently Asked Questions
        </h1>
        <div class="accordion" id="faqAccordion">
          <div class="card" v-for="(faq, index) in faqs" :key="index">
            <div class="card-header" :id="'heading' + index">
              <h2 class="accordion-header">
                <button
                  :class="{
                    'arrow-open': activeIndex === index,
                    'arrow-closed': activeIndex !== index,
                  }"
                  class="accordion-button"
                  type="button"
                  @click="toggle(index)"
                  :aria-expanded="activeIndex === index ? 'true' : 'false'"
                  :aria-controls="'collapse' + index"
                >
                  {{ faq.question }}
                  <span></span>
                </button>
              </h2>
            </div>
            <div
              :id="'collapse' + index"
              class="accordion-collapse collapse"
              :class="{ show: activeIndex === index }"
              :aria-labelledby="'heading' + index"
              data-bs-parent="#faqAccordion"
            >
              <div class="card-body" v-html="faq.answer"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FAQ',
  data() {
    return {
      faqs: [
        {
          question:
            'What do I do if I am having trouble participating in the program?',
          answer:
            'Please visit <a href="https://www.wkkellogg.com/en-us/contact-us.html" target="_blank">Contact Us</a>.',
        },
        {
          question: 'What are the participating cereal products?',
          answer:
            'You can view the full list of participating products <a href="http://snipp.us/!cumUv" target="_blank">here</a>.',
        },
        {
          question: 'How long do I have to send in my receipt?',
          answer:
            'Participants with qualifying receipts will have up to 30 days after the promotional period to send in a receipt, no later than 5/30/25.',
        },
        {
          question:
            'How long after my submission will I receive my digital reward for activewear?',
          answer:
            'Participants will receive their digital activewear rewards within 7-10 days after their submission has been validated.',
        },          
      ],
      activeIndex: null,
    };
  },
  methods: {
    toggle(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
  },
};
</script>

<style scoped>
#faqAccordion > .card {
  margin-bottom: 15px;
  border-radius: 0px;
  border: 1px solid #404040;
}

#faqAccordion > .card > .card-header {
  padding: 0px;
}

#faqAccordion .accordion-button {
  font-size: 1.1rem;
  color: #000;
  font-weight: 500;
  padding-right: 30px;
  box-shadow: none;
}

#faqAccordion .accordion-button:focus,
#faqAccordion .accordion-button.focus,
#faqAccordion .accordion-button:hover {
  text-decoration: none;
}

.accordion-button:not(.collapsed) {
  background-color: #e9ecef;
}
.accordion-button {
  transition: background-color 0.3s ease;
}
.accordion-button::after,
.accordion-button:not(.collapsed)::after {
  font-family: 'FontAwesome';
  background-image: none;
}
.accordion-button.arrow-open::after {
  content: '\f078';
}

.accordion-button.arrow-closed::after {
  content: '\f077';
}
</style>
